import Request from './baseRequest'
const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _getInteractionsReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/project/interactions?${params}`,
    config
  ) 
}

const _getInteractions = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/interactions?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/interactions`

  return Request.get(
    url,
    config
  )
}

const _getGeneralTransactionsReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/project/transactions-revenue?${params}`,
    config
  )
}

const _getGeneralTransactionsByDayReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/project/transactions-by-day?${params}`,
    config
  )
}

const _getTransactionsByDayCsv = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/project/transactions-by-day-csv?${params}`,
    config
  )
}

export default {
  getInteractionsReport: _getInteractionsReport,
  getGeneralTransactionsReport: _getGeneralTransactionsReport,
  getGeneralTransactionsByDayReport: _getGeneralTransactionsByDayReport,
  getInteractions : _getInteractions,
  getTransactionsByDayCsv: _getTransactionsByDayCsv
}